// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__wrHhG","container_stagging":"Dashboard_container_stagging__GhlKD","container_cards":"Dashboard_container_cards__GH6KT"};